import 'react-datepicker/dist/react-datepicker.css'

import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Form } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { getBrowserTimeZone } from '../../util/date.util'

const propTypes = {
  /**
   * id of the field
   */
  id: PropTypes.string.isRequired,
  /**
   * Name of the field
   * If no name is passed id is used as name
   */
  name: PropTypes.string,
  /**
   * Title of the field. Must be a FormattedMessage id
   */
  title: PropTypes.string,
  /**
   * Callback called when an option is selected
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Value of the field
   */
  value: PropTypes.string,
  /**
   * validation errors messages
   */
  errors: PropTypes.arrayOf(PropTypes.string),
  /**
   * Class to style the title
   */
  titleClassName: PropTypes.string,
  /**
   * Class to override default control styles
   */
  className: PropTypes.string,
  /**
   * Indicates if field is required
   */
  required: PropTypes.bool,
  /**
   * If true, shows timezone below the field
   */
  showTimezone: PropTypes.bool,
  /**
   * Information to be shown below the field
   */
  info: PropTypes.string,
  /**
   * Merged with the default wrapper margin (e.g. `mb-0` utilities) when embedding in a custom row layout.
   */
  containerClassName: PropTypes.string,
}

function DateTimeField(props) {
  const {
    id,
    name = null,
    title = null,
    onChange,
    value = null,
    errors = [],
    titleClassName = '',
    className = '',
    required = false,
    showTimezone = false,
    info = '',
    containerClassName = '',
    ...rest
  } = props ?? {}

  return (
    <div className={clsx('mb-3', containerClassName)}>
      {title && (
        <p className={clsx('mb-2', titleClassName)}>
          <FormattedMessage id={title} />
          {required && <span className="font-size-regular text-color-danger">*</span>}
        </p>
      )}

      <Form.Control
        {...rest}
        type="datetime-local"
        id={id}
        name={name || id}
        value={value}
        onChange={onChange}
        className={clsx(errors?.length && 'error-border', className)}
      />

      {showTimezone && (
        <div className="text-color-secondary font-size-sm">
          <FormattedMessage id="GENERAL.TIME_ZONE" />
          :&nbsp;{getBrowserTimeZone()}
        </div>
      )}

      {info && <div className="text-color-secondary font-size-sm">{info}</div>}

      {errors?.map((errorMessage) => (
        <div key={errorMessage} className={clsx('text-color-danger', !showTimezone && !info ? 'mt-2' : '')}>
          {errorMessage}
        </div>
      ))}
    </div>
  )
}

DateTimeField.propTypes = propTypes

export default DateTimeField
